import { actions as formActions } from 'react-redux-form'

import * as h2Api from '../h2Api'

export const SURVEY_LOADED = 'SURVEY_DATA_LOADED'
export const SURVEY_FIELD_CHANGED = 'SURVEY_FIELD_CHANGED'
export const SURVEY_SUBMITTED = 'SURVEY_SUBMITTED'
export const SURVEY_VALIDATE = 'SURVEY_VALIDATE'
export const SURVEY_UNLOADED = 'SURVEY_UNLOADED'
export const SURVEY_REORDER_QUESTION = 'SURVEY_REORDER_QUESTION'
export const SURVEY_EDIT_QUESTION = 'SURVEY_EDIT_QUESTION'

export const SURVEY_SELECTED_FOR_RENAME = 'SURVEY_SELECTED_FOR_RENAME'
export const SURVEY_RENAME_TITLE_TYPING = 'SURVEY_RENAME_TITLE_TYPING'

export const LOAD_SURVEYS = 'PROFILE_LOAD_SURVEYS'
export const SELECT_EDIT_SURVEY = 'PROFILE_SELECT_EDIT_SURVEY'
export const SELECT_NEW_SURVEY = 'PROFILE_SELECT_NEW_SURVEY'
export const UNSELECT_EDIT_SURVEY = 'PROFILE_UNSELECT_EDIT_SURVEY'

export const CREATE_SURVEY = 'PROFILE_CREATE_SURVEY'
export const SELECT_SURVEY = 'PROFILE_SELECT_SURVEY'
export const DISMISS_SURVEY_MODAL = 'PROFILE_DISMISS_SURVEY_MODAL'
export const SURVEY_DELETE_QUESTION = 'SURVEY_DELETE_QUESTION'
export const SET_SURVEY_NAME = 'SET_SURVEY_NAME'

export const ADD_SURVEY_QUESTION = 'ADD_SURVEY_QUESTION'
export const SAVE_SURVEY = 'PROFILE_SAVE_SURVEY'
export const LOAD_USER_SURVEYS = 'LOAD_USER_SURVEYS'

export const CREATE_SYSTEM_SURVEY = 'CREATE_SYSTEM_SURVEY'
export const SAVE_SYSTEM_SURVEY = 'SAVE_SYSTEM_SURVEY'

export const LOAD_SURVEY_RESULTS = 'LOAD_SURVEY_RESULTS'
export const SET_SURVEY_RESPONSES = 'SET_SURVEY_RESPONSES'
export const CLEAR_SURVEY_RESPONSES = 'CLEAR_SURVEY_RESPONSES'

/** todo add-profileId */
export const respondToQuestion =
  (survey, question, response, multiAllowed, mode = 'replacement') =>
  dispatch => {
    console.log(survey, question, response)

    return dispatch({
      type: SURVEY_FIELD_CHANGED,
      question,
      response,
      multiAllowed: !!multiAllowed,
      mode
    })
  }

export const updateSurveyName = value => dispatch => {
  return dispatch({ type: SURVEY_RENAME_TITLE_TYPING, value })
}

export const doRename = survey => dispatch => {
  console.log('here')
  const url = `/survey/${survey.id}`

  return dispatch(
    h2Api.put(
      url,
      survey
    )({
      type: SELECT_EDIT_SURVEY
    })
  ).then(f => {
    dispatch(Promise.resolve(dispatch({ type: SURVEY_SELECTED_FOR_RENAME, name: null })))

    return f
  })
}

export const setUserResponses = surveyResponse => dispatch => {
  return dispatch({ type: SET_SURVEY_RESPONSES, surveyResponse })
}

export const cancelRename = () => (dispatch, getState) => {
  const v = getState().surveyEdit.originalTitle

  dispatch({ type: SURVEY_RENAME_TITLE_TYPING, value: v })

  return Promise.resolve(dispatch({ type: SURVEY_SELECTED_FOR_RENAME, name: null }))
}

export const selectForRename = survey => dispatch => {
  dispatch(formActions.change('survey.surveyForms.createSurveyForm', survey))

  return Promise.resolve(
    dispatch({ type: SURVEY_SELECTED_FOR_RENAME, name: survey.name })
  )
}

export const listSurveysForUser = () => dispatch => {
  const url = `/survey/list`

  return dispatch(
    h2Api.get(url)({
      type: LOAD_USER_SURVEYS
    })
  )
}

export const getSurveyResults = surveyId => dispatch => {
  const url = `/survey/${surveyId}/responses`

  return dispatch(
    h2Api.get(url)({
      type: LOAD_SURVEY_RESULTS
    })
  )
}

export const loadSurveys = (profileType, profileId, openModal) => dispatch => {
  console.log('here')
  const url = `/profiles/${profileType}/${profileId}/surveys`

  return dispatch(
    h2Api.get(url)({
      type: LOAD_SURVEYS,
      openModal: !!openModal
    })
  )
}

export const saveQuestion = (survey, question) => dispatch => {
  const url = `/survey/${survey.id}/question`

  return dispatch(
    h2Api.post(
      url,
      question
    )({
      type: ADD_SURVEY_QUESTION
    })
  )
}

export const dismissEditSurveyModal = () => dispatch => {
  dispatch({
    type: DISMISS_SURVEY_MODAL
  })
}

export const validateResponse = (question, response) => dispatch => {
  //console.log(response, question);
  let errorText
  const responseLength = response?.length ?? 0

  switch (question.questionTypeId) {
    case 1: //text
      if (question.responseRequired && (!response || response.trim() === '')) {
        errorText = 'A response is required'
      } else if (question.minLength && question.minLength > responseLength) {
        errorText = `You must enter at least ${question.minLength} characters`
      } else if (question.maxLength && question.maxLength < responseLength) {
        errorText = `You must enter at no more than ${question.maxLength} characters`
      }

      break

    case 4: //occupation choice - fall through
    case 2: //multi choice
      if (question.responseRequired) {
        //only validation allowed
        const defined = response && (responseLength > 0 || typeof response === 'number')
        const isEmpty =
          !defined ||
          (question.multiResponses && Array.isArray(response) && response.length === 0) ||
          (question.multiResponses &&
            Array.isArray(response) &&
            response.length === 1 &&
            response[0] === '') ||
          (!question.multiResponses && response === '')
        const valid = defined && !isEmpty

        if (!valid) {
          errorText = 'A response is required'
        }
      }

      break

    case 3: //rating
      if (question.responseRequired && (!response || response === -1)) {
        errorText = 'A response is required'
      } else if (question.minLength && question.minLength > response) {
        errorText = `Your response must be at least ${question.minLength}`
      } else if (question.maxLength && question.maxLength < response) {
        errorText = `Your response must be at most ${question.maxLength}`
      }

      break

    default:
  }

  const errors = { [question.id]: errorText }

  dispatch({ type: SURVEY_VALIDATE, errors })

  return errorText
}

export const submitSurvey = (survey, form) => (dispatch, getState) => {
  const surveySt = getState().surveys
  const resp = surveySt.surveyResponse
  const profileId = surveySt.profileId
  const jsonToSubmit = profileId ? { ...resp, profileId } : resp
  const formData = new FormData(form)

  formData.append('surveyResponses', JSON.stringify(jsonToSubmit))

  return dispatch(
    h2Api.postFile(`/survey/${survey.id}/responses`, formData)({ type: SURVEY_SUBMITTED })
  )
}

export const loadSurvey = s => {
  return h2Api.get(`/survey/${s}`)({ type: SURVEY_LOADED })
}

export const unloadSurvey = s => dispatch => {
  return dispatch({ type: SURVEY_UNLOADED })
}

export const deleteSurveyQuestion = (survey, question) => dispatch => {
  const url = `/survey/${survey.id}/question/${question.id}`

  return dispatch(
    h2Api.doDelete(url)({ type: SURVEY_DELETE_QUESTION, surveyQuestionId: question.id })
  )
}

export const selectSurveyQuestionForEdit = surveyQuestion => dispatch => {
  console.log(surveyQuestion)
  dispatch(resetQuestionForms())

  if (surveyQuestion) {
    let formName = null
    let formData = {
      questionTypeId: surveyQuestion.questionTypeId,
      name: surveyQuestion.text,
      responseRequired: surveyQuestion.responseRequired,
      description: surveyQuestion.description
    }

    if (surveyQuestion.hasOwnProperty('id')) {
      formData = {
        ...formData,
        id: surveyQuestion.id
      }
    }

    switch (surveyQuestion.questionTypeId) {
      case 2:
        formName = 'survey.surveyForms.surveyMultiChoiceQuestionForm'
        formData = {
          ...formData,
          multipleResponses: surveyQuestion.multipleResponses,
          noSelectionText: surveyQuestion.placeholder,
          options: surveyQuestion.options
        }
        break
      case 3:
        formName = 'survey.surveyForms.surveyRatingQuestionForm'
        formData = {
          ...formData,
          maxValue: surveyQuestion.maxValue,
          minValue: surveyQuestion.minValue,
          maxValueExplanation: surveyQuestion.maxValueExplanation,
          minValueExplanation: surveyQuestion.minValueExplanation
        }
        break
      case 4:
        formName = 'survey.surveyForms.surveyMultiChoiceOccupationForm'
        formData = {
          ...formData,
          multipleResponses: surveyQuestion.multipleResponses,
          minJobZone: surveyQuestion.minJobZone,
          maxJobZone: surveyQuestion.maxJobZone,
          primaryInterest: surveyQuestion.primaryInterest,
          cluster: surveyQuestion.cluster
        }
        break
      case 5:
        formName = 'survey.surveyForms.surveyMultiChoiceInstructionalProgramForm'
        formData = {
          ...formData,
          multipleResponses: surveyQuestion.multipleResponses,
          noSelectionText: surveyQuestion.placeholder
        }
        break
      case 6:
        formName = 'survey.surveyForms.surveyMultiChoiceEducationalInstitutionForm'
        formData = {
          ...formData,
          multipleResponses: surveyQuestion.multipleResponses,
          noSelectionText: surveyQuestion.placeholder,
          stateOptions: surveyQuestion.stateOptions,
          studentBodyOptions: surveyQuestion.studentBodyOptions,
          collegeSizeOptions: surveyQuestion.collegeSizeOptions
        }
        break
      case 7:
        formName = 'survey.surveyForms.surveyFileQuestionForm'
        formData = {
          ...formData,
          multipleResponses: surveyQuestion.multipleResponses,
          noSelectionText: surveyQuestion.placeholder
        }
        break
      case 8:
        formName = 'survey.surveyForms.surveyMultiChoiceClusterForm'
        formData = {
          ...formData,
          multipleResponses: surveyQuestion.multipleResponses,
          noSelectionText: surveyQuestion.placeholder
        }
        break
      default:
        formName = 'survey.surveyForms.surveyTextQuestionForm'
        formData = {
          ...formData,
          multiLine: surveyQuestion.multiLine,
          validateInput: surveyQuestion.validateInput || 1,
          userDefaultOptions: surveyQuestion.userDefaultOptions,
          validationOptions: surveyQuestion.validationOptions,
          minLength: surveyQuestion.minLength,
          maxLength: surveyQuestion.maxLength
        }
        break
    }

    dispatch(formActions.change(formName, formData))
    console.log('Set to: ', formName, formData)
  }

  return dispatch({ type: SURVEY_EDIT_QUESTION, surveyQuestion })
}

export const addOption = (formName, key) => dispatch => {
  console.log(formName, key)
  dispatch(formActions.push(`${formName}.${key}`, { option: '' }))
}

export const moveOption = (formName, key, from, to) => dispatch => {
  console.log(formName, key)
  dispatch(formActions.move(`${formName}.${key}`, from, to))
}

export const removeOption = (formName, key, idx) => dispatch => {
  console.log(`Removing ${idx}`)
  dispatch(formActions.remove(`${formName}.${key}`, idx))
}

export const resetQuestionForms = () => dispatch => {
  dispatch(formActions.reset('survey.surveyForms.surveyTextQuestionForm'))
  dispatch(formActions.reset('survey.surveyForms.surveyFileQuestionForm'))
  dispatch(formActions.reset('survey.surveyForms.surveyMultiChoiceQuestionForm'))
  dispatch(formActions.reset('survey.surveyForms.surveyRatingQuestionForm'))
  dispatch(
    formActions.reset('survey.surveyForms.surveyMultiChoiceInstructionalProgramForm')
  )
  dispatch(
    formActions.reset('survey.surveyForms.surveyMultiChoiceEducationalInstitutionForm')
  )
}

export const unselectSurveyForEdit = () => dispatch => {
  return Promise.resolve(dispatch({ type: UNSELECT_EDIT_SURVEY }))
}

export const reorderQuestion = (surveyId, questionId, targetPosition) => dispatch => {
  const url = `/api/v1/survey/${surveyId}/reorder/${questionId}`
  const json = {
    newPosition: targetPosition
  }

  console.log(json)

  return dispatch(h2Api.post(url, json)({ type: SURVEY_REORDER_QUESTION }))
}

export const createNewSurveyForEdit = () => dispatch => {
  return Promise.resolve(dispatch({ type: SELECT_NEW_SURVEY }))
}

export const saveNewProfileSurvey = (profileType, profileId, data) => dispatch => {
  return dispatch(
    h2Api.post(
      `/profiles/${profileType}/${profileId}/surveys/create`,
      data
    )({ type: SELECT_EDIT_SURVEY })
  )
}

export const cloneProfileSurveyAction =
  (profileType, profileId, surveyId) => dispatch => {
    return dispatch(
      h2Api.post(
        `/profiles/${profileType}/${profileId}/surveys/${surveyId}/clone`,
        {}
      )({ type: CREATE_SURVEY })
    )
  }

export const selectSurveyForEdit = surveyId => dispatch => {
  return dispatch(h2Api.get(`/survey/${surveyId}`)({ type: SELECT_EDIT_SURVEY }))
}

export const saveSurvey = (surveyId, data) => dispatch => {
  return dispatch(h2Api.put(`/survey/${surveyId}`, data)({ type: SAVE_SURVEY }))
}

export const saveNewSurvey = data => dispatch => {
  return dispatch(h2Api.post(`/survey`, data)({ type: CREATE_SURVEY }))
}

export const cloneSurvey = (surveyId, data) => dispatch => {
  return dispatch(h2Api.post(`/survey/${surveyId}/clone`)({ type: CREATE_SYSTEM_SURVEY }))
}
